<template>
  <div class="sky-input-number">
    <itemSearch v-bind="$attrs">
      <el-input-number :value="value" @change="change" v-bind="$attrs" ref="input"></el-input-number>
      <div slot="toolTips">{{toolContent}}</div>
    </itemSearch>
  </div>
</template>
<script>
import itemSearch from "@/components/iglobalwin/formComponents/SkySuffix.vue";
export default {
  name: "sky-input-number",
  props: ["value", "toolContent"],
  inheritAttrs: false,
  data() {
    return {
      val: ""
    };
  },
  methods: {
    change(val) {
      this.$emit("input", val);
    }
  },
  watch: {
    value(val) {
      this.val = val;
    }
  },
  components: { itemSearch }
};
</script>
<style scoped lang="scss">
.sky-input-number {
  .el-input-number--medium {
    width: 100%;
  }
}
</style>
